import request from '@/utils/request'
// const apiPrefix = `${process.env.VUE_APP_BASE_API}/`
/**系统设置 */
//菜单管理(左侧菜单列表)
export const getMenu = (params, config = {}) => {
  return request.post('menu/findByAll', params, config)
}
//获取菜单管理列表+分页
export const getFindByList = (page,size,params,config = {}) => {
  return request.post(`menu/findByList/${page}/${size}`,params,config)
}
//添加
export const menuAdd = (params,config = {}) => {
  return request.post('menu/add',params,config)
}
//修改
export const menuEdit = (params,config = {}) => {
  return request.post('menu/set',params,config)
}
//详情
export const menuGet = (id,config = {}) => {
  return request.get(`menu/get/${id}`,config)
}
//删除
export const menuDel = (id,config = {}) => {
  return request.get(`menu/del/${id}`,config)
}

/**角色管理 */
//获取角色管理分页信息
export const getRoleFindByList = (page,size,params,config = {}) => {
  return request.post(`role/findByList/${page}/${size}`,params,config)
}
//获取角色列表
export const getRoleFindByAll = (params, config = {}) => {
  return request.post('role/findByAll',params,config)
}
//添加
export const roleAdd = (params,config = {}) => {
  return request.post('role/add',params,config)
}
//修改
export const roleEdit = (params,config = {}) => {
  return request.post('role/set',params,config)
}
//详情
export const roleGet = (id,config = {}) => {
  return request.get(`role/get/${id}`,config)
}
//删除
export const roleDel = (id,config = {}) => {
  return request.get(`role/del/${id}`,config)
}


/**用户管理 */
//获取用户管理分页列表
export const getRlAdminUserList = (page,size, config = {}) => {
  return request.post(`rlAdminUser/findByList/${page}/${size}`,config)
}
//添加
export const rlAdminUserAdd = (params,config = {}) => {
  return request.post('rlAdminUser/add',params,config)
}
//修改
export const rlAdminUserEdit = (params,config = {}) => {
  return request.post('rlAdminUser/set',params,config)
}
//详情
export const rlAdminUserGet = (id,config = {}) => {
  return request.get(`rlAdminUser/get/${id}`,config)
}
//删除
export const rlAdminUserDel = (id,config = {}) => {
  return request.get(`rlAdminUser/del/${id}`,config)
}

/**登录用户相关 */
//登录接口
export const login = (params,config = {}) => {
  return request.post('rlAdminUser/login',params,config)
}
//重置密码
export const rlAdminUserResetPsd = (params,config = {}) => {
  return request.post('rlAdminUser/reset/password',params,config)
}
// 获取登录用户信息
export const rlAdminUserInfo = (config = {}) => {
  return request.get('rlAdminUser/get',config)
}

// 导入接口
// export function apiImportFile(params){
//   return http({
//     url:'/client/ccManage/upload',
//     method:'post',
//     data:params,
//     headers:{
//       'content-type':'multipart/form-data'
//     }
//   })
// }
